export const ANNOTATION_SELECT_EVENT = "magic-md:annotation-select";
export const ANNOTATION_BLOCK_COMMENT_EVENT = "magic-md:annotation-block-comment";
export const ANNOTATION_REBIND_EVENT = "magic-md:annotation-rebind";

export interface AnnotationSelectDetail {
    documentPath: string;
    annotationId: string;
    openPopover?: boolean;
}

export interface AnnotationBlockCommentDetail {
    documentPath: string;
    blockId: string;
    label?: string;
    outputHash?: string;
    rect: {
        left: number;
        top: number;
        bottom: number;
    };
}

export interface AnnotationRebindDetail {
    documentPath: string;
    annotationId: string;
}

export function dispatchAnnotationSelect(detail: AnnotationSelectDetail) {
    window.dispatchEvent(
        new CustomEvent(ANNOTATION_SELECT_EVENT, {
            detail,
        }),
    );
}

export function dispatchAnnotationBlockComment(detail: AnnotationBlockCommentDetail) {
    window.dispatchEvent(
        new CustomEvent(ANNOTATION_BLOCK_COMMENT_EVENT, {
            detail,
        }),
    );
}

export function dispatchAnnotationRebind(detail: AnnotationRebindDetail) {
    window.dispatchEvent(
        new CustomEvent(ANNOTATION_REBIND_EVENT, {
            detail,
        }),
    );
}
